<template>
  <div class="md-layout">
    <md-card>
      <md-card-content>
        <div class="md-layout-item md-size-100" style="padding-bottom: 20px">
          <md-toolbar class="md-success" md-elevation="1">
            <div class="md-toolbar-row">
              <div class="md-toolbar-section-start">
                <h3
                  class="md-title"
                  style="padding-left: 20px; padding-bottom: 10px"
                >
                  空调新风系统
                </h3>
              </div>
              <div class="md-toolbar-section-end">
                <md-button class="md-success md-sm" @click="clearFilter">
                  <md-icon>preview</md-icon>开启客户端
                </md-button>
                <md-button class="md-success md-sm" @click="clearFilter">
                  <md-icon>cancel</md-icon>关闭
                </md-button>
              </div>
            </div>
          </md-toolbar>
        </div>

        <Split
          :style="{
            height: !fullscreen
              ? 'calc(100vh - 155px - 120px)'
              : 'calc(100vh - 70px)',
          }"
        >
          <SplitArea size="15%" :minSize="100" style="padding-left: 15px">
            <Tree
              :setting="setting"
              :nodes="treeData"
              ref="tree"
              class="md-tree"
            />
          </SplitArea>
          <SplitArea size="84%" style="padding-left: 25px; padding-right: 3px">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide>
                <video-player
                  class="vjs-custom-skin"
                  ref="videoPlayer"
                  :options="playerOptions"
                  :playsinline="true"
                  @play="onPlayerPlay($event)"
                  @pause="onPlayerPause($event)"
                  @ended="onPlayerEnded($event)"
                  @loadeddata="onPlayerLoadeddata($event)"
                  @waiting="onPlayerWaiting($event)"
                  @playing="onPlayerPlaying($event)"
                  @timeupdate="onPlayerTimeupdate($event)"
                  @canplay="onPlayerCanplay($event)"
                  @canplaythrough="onPlayerCanplaythrough($event)"
                  @ready="playerReadied"
                  @statechanged="playerStateChanged($event)"
                >
                </video-player>
              </swiper-slide>
              <swiper-slide><img src="img/scene2.jpeg" /></swiper-slide>
              <swiper-slide><img src="img/scene3.jpeg" /></swiper-slide>
              <swiper-slide><img src="img/scene4.jpeg" /></swiper-slide>
              <swiper-slide><img src="img/scene5.jpeg" /></swiper-slide>
              <swiper-slide><img src="img/scene6.jpeg" /></swiper-slide>
              <swiper-slide><img src="img/scene7.jpeg" /></swiper-slide>
              <swiper-slide><img src="img/scene8.jpeg" /></swiper-slide>
              <div
                class="swiper-pagination swiper-pagination-bullets"
                slot="pagination"
              ></div>
              <div
                class="swiper-button-prev"
                slot="button-prev"
                style="color: white"
              ></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
            <!-- <div class="md-layout" style="padding-top: 25px">
              <div
                class="md-layout-item md-size-10"
                style="color: red; padding-left: 100px; padding-top: 10px"
              >
                <h4>¥89</h4>
              </div>
              <div class="md-layout-item md-size-5" style="padding-top: 8px">
                <md-select v-model="period" name="period" id="period">
                  <md-option value="month">月</md-option>
                  <md-option value="year">年</md-option>
                </md-select>
              </div>
              <div class="md-layout-item md-size-20">
                <md-button class="md-danger md-sm" @click="clearFilter">
                  <md-icon>payment</md-icon>购买
                </md-button>
                <md-button
                  class="md-warning md-sm"
                  @click="clearFilter"
                  style="margin-left: 5px"
                >
                  <md-icon>shopping_cart</md-icon>加入购物车
                </md-button>
              </div>
              <div
                class="md-layout-item md-size-5 md_warning"
                style="padding-left: 45px; padding-top: 5px; color: coral"
              >
                <img src="img/gift.png" style="width: 24px; height: 24px" />
              </div>
              <div
                class="md-layout-item md-size-30 md_warning"
                style="padding-left: 0px; padding-top: 11px; color: coral"
              >
                <h6>购买一年服务，免费赠送三个月</h6>
              </div>
              <div
                class="md-layout-item md-size-15 md_warning"
                style="padding-left: 0px; padding-top: 11px; color: coral"
              >
                <img src="img/star.png" style="width: 20px; height: 20px" />
                <img
                  src="img/star.png"
                  style="width: 20px; height: 20px; margin-left: 5px"
                />
                <img
                  src="img/star.png"
                  style="width: 20px; height: 20px; margin-left: 5px"
                />
                <img
                  src="img/star.png"
                  style="width: 20px; height: 20px; margin-left: 5px"
                />
                <img
                  src="img/star.png"
                  style="width: 20px; height: 20px; margin-left: 5px"
                />
              </div>
              <div class="md-layout-item md-size-15">
                <md-button
                  class="md-success md-sm"
                  @click="clearFilter"
                  style="margin-left: 5px"
                >
                  <md-icon>preview</md-icon>开启客户端
                </md-button>
              </div>
            </div> -->
            <div
              class="md-layout-item md-size-100 md-medium-size-100"
              style="padding-top: 35px; padding-left: 0px; padding-right: 0px"
            >
              <tabs
                :tab-name="['项目简介', '团队介绍', '实训室', '评价', '留言']"
                :tab-icon="[
                  'class',
                  'groups_3',
                  'construction',
                  'military_tech',
                  'chat',
                ]"
                flex-column
                nav-pills-icons
                color-button="success"
                style="
                  margin-left: 0px;
                  margin-right: 0px;
                  margin-bottom: 30px;
                  margin-top: 0px;
                "
              >
                <!-- here you can add your content for tab-content -->
                <template slot="tab-pane-1">
                  <div class="md-layout">
                    <label class="md-layout-item md-size-10 md-form-label">
                      项目名称
                    </label>
                    <div class="md-layout-item">
                      <p class="form-control-static">建筑设备监控系统</p>
                    </div>
                  </div>
                  <div class="md-layout">
                    <label class="md-layout-item md-size-10 md-form-label">
                      项目简介
                    </label>
                    <div class="md-layout-item">
                      <p class="form-control-static">
                        建筑设备监控系统是智能建筑中的一个重要系统,是将与建筑物有关的暖通空调、给排水、电力、照明、运输等设备集中监视、控制和管理的综合性系统。建筑设备监控系统是以计算机局域网为通信基础、以计算机技术为核心的计算机控制系统,它具有分散控制和集中管理的功能。
                        建筑物内诸多的机电设备之间存在着内在的相互联系,于是就需要完善的集中和自动化管理。建立机电设备管理系统,达到对机电设备进行综合管理、调度、监视、操作和控制,并达到节能的目的。
                        <br />
                        建筑设备监控系统的作用：
                        <br />
                        a)能提供整体监测,对机电设备故障作出即时察觉及分析,减少因小故障而引起的其他问题,同时节省时间和资金。
                        <br />
                        b)配合自控系统的节能程式操作,减少不必要的能源浪费。
                        <br />
                        c)提供防范性保养,对可能发生的设备问题作出事先维修。
                        <br />
                        d)提高对楼宇的整体管理效率,节省人力和时间。
                      </p>
                    </div>
                  </div>
                  <div class="md-layout">
                    <label class="md-layout-item md-size-10 md-form-label">
                      适用于
                    </label>
                    <div class="md-layout-item">
                      <p class="form-control-static">高职院校</p>
                    </div>
                  </div>
                </template>
                <template slot="tab-pane-2">
                  <div class="md-layout">
                    <label class="md-layout-item md-size-10 md-form-label">
                      负责人
                    </label>
                    <div class="md-layout-item">
                      <p class="form-control-static">
                        雨果<br />教授,长江学者,山西省杰出青年.浙江大学建筑工程学院教授,博士生导师。浙江省151人才,浙江省钱江人才计划获得者。
                        <br />
                        2006 年毕业于清华大学获博士学位,2008
                        年浙江大学师资博士后出站;2008年受Queen's
                        University资助,在英国女王大学访问;2009-2011
                        年获受国家留学基金委“青年骨干教师出国研修计划”和浙江大学“新星计划”资助,在美国UC
                        Berkeley进行学术访问与科研合作。中国建筑学会建材分会理事,中国建筑学会防护与修复材料及应用技术委员会委员,中国建筑学会建筑材料测试技术专业委员会委员,中国土木工程学会混凝土质量委员会委员,2009
                        国际会议“2nd Asia Pacific Young Researchers and
                        Graduates Symposium”组委、2008 国际会议“International
                        Conference on Durability of Concrete
                        Structures”组委等等。
                      </p>
                    </div>
                  </div>
                  <div class="md-layout">
                    <label class="md-layout-item md-size-10 md-form-label">
                      团队成员
                    </label>
                    <div class="md-layout-item">
                      <p class="form-control-static">
                        夏果<br />教授,长江学者,山西省杰出青年.浙江大学建筑工程学院教授,博士生导师。浙江省151人才,浙江省钱江人才计划获得者。
                        <br />
                        2006 年毕业于清华大学获博士学位,2008
                        年浙江大学师资博士后出站;2008年受Queen's
                        University资助,在英国女王大学访问;2009-2011
                        年获受国家留学基金委“青年骨干教师出国研修计划”和浙江大学“新星计划”资助,在美国UC
                        Berkeley进行学术访问与科研合作。中国建筑学会建材分会理事,中国建筑学会防护与修复材料及应用技术委员会委员,中国建筑学会建筑材料测试技术专业委员会委员,中国土木工程学会混凝土质量委员会委员,2009
                        国际会议“2nd Asia Pacific Young Researchers and
                        Graduates Symposium”组委、2008 国际会议“International
                        Conference on Durability of Concrete
                        Structures”组委等等。
                      </p>
                    </div>
                  </div>
                  <div class="md-layout">
                    <label class="md-layout-item md-size-10 md-form-label">
                      团队成员
                    </label>
                    <div class="md-layout-item">
                      <p class="form-control-static">
                        秋果<br />教授,长江学者,山西省杰出青年.浙江大学建筑工程学院教授,博士生导师。浙江省151人才,浙江省钱江人才计划获得者。
                        <br />
                        2006 年毕业于清华大学获博士学位,2008
                        年浙江大学师资博士后出站;2008年受Queen's
                        University资助,在英国女王大学访问;2009-2011
                        年获受国家留学基金委“青年骨干教师出国研修计划”和浙江大学“新星计划”资助,在美国UC
                        Berkeley进行学术访问与科研合作。中国建筑学会建材分会理事,中国建筑学会防护与修复材料及应用技术委员会委员,中国建筑学会建筑材料测试技术专业委员会委员,中国土木工程学会混凝土质量委员会委员,2009
                        国际会议“2nd Asia Pacific Young Researchers and
                        Graduates Symposium”组委、2008 国际会议“International
                        Conference on Durability of Concrete
                        Structures”组委等等。
                      </p>
                    </div>
                  </div>
                  <div class="md-layout">
                    <label class="md-layout-item md-size-10 md-form-label">
                      团队成员
                    </label>
                    <div class="md-layout-item">
                      <p class="form-control-static">
                        冬果<br />教授,长江学者,山西省杰出青年.浙江大学建筑工程学院教授,博士生导师。浙江省151人才,浙江省钱江人才计划获得者。
                        <br />
                        2006 年毕业于清华大学获博士学位,2008
                        年浙江大学师资博士后出站;2008年受Queen's
                        University资助,在英国女王大学访问;2009-2011
                        年获受国家留学基金委“青年骨干教师出国研修计划”和浙江大学“新星计划”资助,在美国UC
                        Berkeley进行学术访问与科研合作。中国建筑学会建材分会理事,中国建筑学会防护与修复材料及应用技术委员会委员,中国建筑学会建筑材料测试技术专业委员会委员,中国土木工程学会混凝土质量委员会委员,2009
                        国际会议“2nd Asia Pacific Young Researchers and
                        Graduates Symposium”组委、2008 国际会议“International
                        Conference on Durability of Concrete
                        Structures”组委等等。
                      </p>
                    </div>
                  </div>
                </template>
                <template slot="tab-pane-3">
                  本实训室侧重于对卫星、无人机等航空航天测量手段获取的数据进行处理和实训等工作,是北斗学院下设实习实训重点实验室之一,主要实验仪器有哈瓦工业级四轴八旋翼无人机一架、五镜头倾斜摄影系统一套、无人机地面站系统一套、高性能图形工作站6台、联想ThinkVision实验电脑35台,实验软件主要包括三维建模软件ContextCapture、GIS平台软件ArcGIS、倾斜摄影建模测量系统DP-Modeler、清华山维EPS等先进的专业软件,以及3ds
                  Max、AutoCAD、CASS、PhotoShop等常规工程类软件。能满足测绘、遥感、地信等专业同学进行空间位置服务相关实习实训任务。
                  <br />
                  <br />
                  <img
                    src="img/room1.jpeg"
                    style="width: 450px; height: 280px; padding-right: 15px"
                  />
                  <img
                    src="img/room2.jpeg"
                    style="width: 450px; height: 280px; padding-right: 15px"
                  />
                  <img
                    src="img/room3.jpeg"
                    style="width: 450px; height: 280px"
                  />
                  <br />
                  <br />
                  本实训室侧重于对卫星、无人机等航空航天测量手段获取的数据进行处理和实训等工作,是北斗学院下设实习实训重点实验室之一,主要实验仪器有哈瓦工业级四轴八旋翼无人机一架、五镜头倾斜摄影系统一套、无人机地面站系统一套、高性能图形工作站6台、联想ThinkVision实验电脑35台,实验软件主要包括三维建模软件ContextCapture、GIS平台软件ArcGIS、倾斜摄影建模测量系统DP-Modeler、清华山维EPS等先进的专业软件,以及3ds
                  Max、AutoCAD、CASS、PhotoShop等常规工程类软件。能满足测绘、遥感、地信等专业同学进行空间位置服务相关实习实训任务。
                  <br />
                  <br />
                  <img
                    src="img/room4.jpeg"
                    style="width: 450px; height: 280px; padding-right: 15px"
                  />
                  <img
                    src="img/room5.jpeg"
                    style="width: 450px; height: 280px"
                  />
                </template>
                <template slot="tab-pane-4">
                  <div
                    class="md-layout"
                    style="padding-top: 25px; padding-bottom: 15px"
                  >
                    <div class="md-layout-item md-size-30">
                      <p class="category">
                        <img
                          src="img/good_sel.png"
                          style="width: 16px; height: 16px"
                        />好评
                      </p>
                    </div>
                    <div class="md-layout-item md-size-30">
                      <img
                        src="img/bad.png"
                        style="width: 16px; height: 16px"
                      />中评
                    </div>
                    <div class="md-layout-item md-size-40">
                      <img
                        src="img/bad.png"
                        style="width: 16px; height: 16px"
                      />差评
                    </div>
                  </div>
                  <div class="md-layout">
                    <label class="md-layout-item md-size-20 md-form-label">
                      内容
                    </label>
                    <div
                      class="md-layout-item md-size-80"
                      style="padding-top: 18px; width: 600px"
                    >
                      <img
                        src="img/star.png"
                        style="width: 20px; height: 20px"
                      />
                      <img
                        src="img/star.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                      <img
                        src="img/star.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                      <img
                        src="img/star_blank.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                      <img
                        src="img/star_blank.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                    </div>
                  </div>
                  <div class="md-layout">
                    <label class="md-layout-item md-size-20 md-form-label">
                      制作
                    </label>
                    <div
                      class="md-layout-item md-size-80"
                      style="padding-top: 18px"
                    >
                      <img
                        src="img/star.png"
                        style="width: 20px; height: 20px"
                      />
                      <img
                        src="img/star.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                      <img
                        src="img/star.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                      <img
                        src="img/star.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                      <img
                        src="img/star_blank.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                    </div>
                  </div>
                  <div class="md-layout">
                    <label class="md-layout-item md-size-20 md-form-label">
                      体验
                    </label>
                    <div
                      class="md-layout-item md-size-80"
                      style="padding-top: 18px"
                    >
                      <img
                        src="img/star.png"
                        style="width: 20px; height: 20px"
                      />
                      <img
                        src="img/star.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                      <img
                        src="img/star_blank.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                      <img
                        src="img/star_blank.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                      <img
                        src="img/star_blank.png"
                        style="width: 20px; height: 20px; margin-left: 5px"
                      />
                    </div>
                  </div>
                </template>
                <template slot="tab-pane-5">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <time-line plain type="simple">
                        <time-line-item
                          inverted
                          badge-type="success"
                          badge-icon="pending"
                        >
                          <div slot="header">
                            <div class="md-layout">
                              <div class="md-layout-item md-size-70">
                                <span class="badge badge-success">林书豪</span>
                              </div>
                              <div class="md-layout-item md-size-30">
                                <h6>2022-8-31 20:18</h6>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div slot="content">
                            体验比错,希望继续丰富功能
                            <hr />
                            <md-button
                              slot="title"
                              class="md-button md-success md-round md-sm"
                            >
                              <md-icon>insert_comment</md-icon>
                            </md-button>
                          </div>
                        </time-line-item>

                        <time-line-item
                          inverted
                          badge-type="danger"
                          badge-icon="pending"
                        >
                          <div slot="header">
                            <div class="md-layout">
                              <div class="md-layout-item md-size-70">
                                <span class="badge badge-danger">明月儿</span>
                              </div>
                              <div class="md-layout-item md-size-30">
                                <h6>2022-8-15 20:18</h6>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div slot="content">
                            不咋地，问题太多了，好好测试啊
                            <hr />
                            <md-button
                              slot="title"
                              class="md-button md-danger md-sm md-round"
                            >
                              <md-icon>insert_comment</md-icon>
                            </md-button>
                          </div>
                        </time-line-item>

                        <time-line-item
                          inverted
                          badge-type="success"
                          badge-icon="pending"
                        >
                          <div slot="header">
                            <div class="md-layout">
                              <div class="md-layout-item md-size-70">
                                <span class="badge badge-success">李治军</span>
                              </div>
                              <div class="md-layout-item md-size-30">
                                <h6>2022-8-10 20:18</h6>
                              </div>
                            </div>
                          </div>

                          <div slot="content">
                            内容还得继续丰富,安防设备监控、消防排水系统、空调新风实验，大海潮汐检测，轮船电气化都没有的啊
                            <hr />
                            <md-button
                              slot="title"
                              class="md-button md-success md-sm md-round"
                            >
                              <md-icon>insert_comment</md-icon>
                            </md-button>
                          </div>
                        </time-line-item>
                      </time-line>
                    </div>
                  </div>
                </template>
              </tabs>
            </div>
          </SplitArea>
        </Split>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
import Tree from "vue-giant-tree";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Tabs, TimeLine, TimeLineItem } from "@/components";
// import "swiper/dist/css/swiper.css";
// import "video.js/dist/video-js.css";
// import "../../../assets/css/custom-theme.css";
import { videoPlayer } from "vue-video-player";

export default {
  components: {
    Tree,
    SlideYDownTransition,
    Swiper,
    SwiperSlide,
    videoPlayer,
    Tabs,
    TimeLine,
    TimeLineItem,
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      playerOptions: {
        height: "360",
        autoplay: true,
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            // mp4
            src: "http://vjs.zencdn.net/v/oceans.mp4",
            // webm
            // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          },
        ],
        poster:
          "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
      },
      computed: {
        player() {
          return this.$refs.videoPlayer.player;
        },
      },
      period: "month",

      setting: {
        check: {
          //树是否带复选框或者单选框
          enable: false,
        },
        data: {
          simpleData: {
            //是否使用简单数据模式
            enable: true,
            //树节点id,一般是后台数据库主键
            idKey: "id",
            //父级id
            pIdKey: "pid",
            rootPId: "0",
          },
        },
        //ztree回调函数
        callback: {
          //树选择事件
          onClick: this.treeNodeClick,
        },
      },
      treeData: [
        { id: 1, pid: 0, name: "项目一", open: true },
        { id: 2, pid: 1, name: "任务1-1" },
        { id: 3, pid: 1, name: "任务1-2" },
        { id: 4, pid: 1, name: "任务1-3" },
        { id: 5, pid: 1, name: "任务1-4" },
        { id: 6, pid: 1, name: "任务1-5" },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.swiper {
  width: 100%;
  height: 400px;
}
.swiper-pagination-bullet-custom {
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: #000;
  opacity: 1;
  background: rgba(0, 0, 0, 0.2);
}
.swiper-pagination-bullet-custom.swiper-pagination-bullet-active {
  color: #fff;
  background: #007aff;
}
.md-card img {
  height: 360px;
}

.form-control-static {
  margin-top: 9px;
}

.md-card .md-card-content .md-form-label {
  text-align: left;
}
</style>